import { combineReducers } from 'redux'

import { reducer as aiNotetakerBeta } from 'features/billing/ai_notetaker_beta_slice'
import { reducer as analyticsSlice } from 'features/billing/analytics_slice'
import { reducer as availableAddons } from 'features/billing/available_addons_slice'
import { reducer as billingInfo } from 'features/billing/billing_info_slice'
import { reducer as billingMaintenanceBanner } from 'features/billing/billing_maintenance_banner_slice'
import { reducer as certCaptureToken } from 'features/billing/cert_capture_token_slice'
import { reducer as checkoutInfo } from 'features/billing/checkout_info_slice'
import { reducer as checkoutPaymentMethod } from 'features/billing/checkout_payment_method_slice'
import { reducer as contactSupport } from 'features/billing/contact_support_slice'
import { reducer as createSubscription } from 'features/billing/create_subscription_slice'
import { reducer as currentSubscription } from 'features/billing/current_subscription_slice'
import { reducer as downgrade } from 'features/billing/downgrade_slice'
import { reducer as featureInfo } from 'features/billing/feature_info_slice'
import { reducer as changeCreditCardModal } from 'features/billing/modals/change_credit_card_modal/slice'
import { reducer as churnModals } from 'features/billing/modals/churn_modals_slice'
import { reducer as promptToRemoveScheduledDowngrade } from 'features/billing/modals/prompt_to_remove_scheduled_downgrade_modal'
import {
  reducer as promptToRemoveNonRenewingDowngrade
} from 'features/billing/modals/prompt_to_remove_scheduled_downgrade_modal/non_renewing'
import { reducer as taxInformationModal } from 'features/billing/modals/tax_information_modal/slice'
import { reducer as nextBill } from 'features/billing/next_bill_slice'
import { reducer as noAddingSeats } from 'features/billing/no_adding_seats_slice'
import { reducer as payment } from 'features/billing/payment_slice'
import { reducer as policy } from 'features/billing/policy_slice'
import { reducer as quickPurchase } from 'features/billing/quick_purchase_slice'
import { reducer as removeDowngrade } from 'features/billing/remove_downgrade_slice'
import { reducer as reactivation } from 'features/billing/stages/paid_stage/reactivation_popup/slice'
import { reducer as transactionHistory } from 'features/billing/transaction_history_slice'
import { reducer as trialExtension } from 'features/billing/trial_extension_slice'
import { reducer as upcomingInvoice } from 'features/billing/upcoming_invoice_slice'
import { reducer as updateBillingInformation } from 'features/billing/update_billing_information_slice'
import { reducer as upgradeSubscription } from 'features/billing/upgrade_subscription_slice'
import { reducer as userFeatures } from 'features/billing/user_features_slice'

export const reducer = combineReducers({
  aiNotetakerBeta,
  analyticsSlice,
  availableAddons,
  certCaptureToken,
  currentSubscription,
  nextBill,
  policy,
  quickPurchase,
  reactivation,
  transactionHistory,
  changeCreditCardModal,
  updateBillingInformation,
  payment,
  upcomingInvoice,
  downgrade,
  removeDowngrade,
  noAddingSeats,
  createSubscription,
  checkoutInfo,
  billingInfo,
  billingMaintenanceBanner,
  upgradeSubscription,
  contactSupport,
  checkoutPaymentMethod,
  userFeatures,
  featureInfo,
  promptToRemoveScheduledDowngrade,
  promptToRemoveNonRenewingDowngrade,
  trialExtension,
  taxInformationModal,
  churnModals
})
